import type { BrandResponse, Brand } from '@/types/responses/brandResponse'

export const useBrandStore = defineStore('brand', () => {
  const brand = ref<Brand | null>(null)

  const setBrand = (data: BrandResponse) => {
    brand.value = data.brand
  }

  const $reset = () => {
    brand.value = null
  }

  const getBrand = async (domain?: string): Promise<BrandResponse | undefined> => {
    try {
      if (!domain) {
        console.error('Domain origin is not provided')
        return
      }

      const { response } = useApiFetch('/brand/getbrand', { query: { domain } })

      const data: BrandResponse = await response

      setBrand(data)

      return data
    } catch (error) {
      console.error('Error fetching brand:', error)

      throw error
    }
  }

  return {
    brand,
    setBrand,
    $reset,
    getBrand
  }
})
